export default __webpack_public_path__ + "static/media/what-if-3.344adbd3.png";